import { Lightbulb } from 'lucide-react';
import Categories from '../Categories';
import ProjectQuestionInsights from '../ProjectQuestionInsights';
import { resolveTranslation } from '@/utils/resolveTranslation';
import { translateThemesAndOpportunities } from '@/pages/projects/single-project/Content/project_results/resultsPageTranslations';
import type { CategoryApiResponse, InsightsSubset, SelectedCategory } from '@/types';

interface DataZoneProps {
  categories?: CategoryApiResponse;
  isPendingCategories: boolean;
  insights?: InsightsSubset;
  isLoading: boolean;
  analysisLanguage: string;
  onSelectCategory: (category: SelectedCategory) => void;
  projectId?: string;
  questionID: string;
  questionText: string;
  isPendingInterviewQuestions: boolean;
  showCategoryLoadingIndicator: boolean;
}

function DataZone({
  categories,
  isPendingCategories,
  insights,
  isLoading,
  analysisLanguage,
  onSelectCategory,
  projectId,
  questionID,
  questionText,
  isPendingInterviewQuestions,
  showCategoryLoadingIndicator,
}: DataZoneProps) {
  // Show legacy themes + opportunities only when new-schema patterns_and_trends is absent
  const consolidated = !insights?.patterns_and_trends?.length
    ? [...(insights?.themes || []), ...(insights?.opportunities || [])]
    : [];

  return (
    <div className="flex flex-col gap-5 rounded-xl bg-neutral-50/50 p-5 -mx-1">
      {/* Categories */}
      <Categories
        projectId={projectId}
        questionID={questionID}
        questionText={questionText}
        analysisLanguage={analysisLanguage}
        onSelectCategory={onSelectCategory}
        categories={categories}
        isPendingCategories={isPendingCategories}
        isPendingInterviewQuestions={isPendingInterviewQuestions}
        showCategoryLoadingIndicator={showCategoryLoadingIndicator}
      />

      {/* Themes & Opportunities */}
      {consolidated.length > 0 && (
        <ProjectQuestionInsights
          data={consolidated}
          title={resolveTranslation(translateThemesAndOpportunities, analysisLanguage)}
          isLoading={isLoading}
          noDataText=""
          icon={<Lightbulb className="h-5 w-5" />}
        />
      )}
    </div>
  );
}

export default DataZone;
